export enum LogLevels {
  Error = 0,
  Warning = 10,
  Notice = 20,
  Debug = 30,
  Trace = 40,
  Off = 100,
}
